import React, {
  useState, useEffect, Fragment,
} from 'react'

import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, func, object, string,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const pixelsPerLetter = 6
const extraSpace = 15
const restOfTheTagsWidth = 22
const plusSomethingTagWidth = 30

function FiltersTags({
  currentlySelectedFiltersObjects = EMPTY_ARRAY,
  handleFilterChange,
  functionToCleanLabel = null,
  tagClassName = null,
  containerRef,
}) {
  const [showMore, setShowMore] = useState(false)
  const [visibleTags, setVisibleTags] = useState(0)
  const [initialAvailableWidth, setInitialAvailableWidth] = useState(0)

  useEffect(() => {
    function handleResize() {
      setInitialAvailableWidth(containerRef.current.clientWidth)
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    let availableWidth = (initialAvailableWidth || containerRef.current.clientWidth) - plusSomethingTagWidth
    let tagsToShow = 0

    for (let i = 0; i < currentlySelectedFiltersObjects.length; i += 1) {
      const { label = '' } = currentlySelectedFiltersObjects[i]
      const displayLabel = functionToCleanLabel ? functionToCleanLabel(label) : label
      const estimatedWidth = displayLabel.length * pixelsPerLetter + restOfTheTagsWidth + extraSpace

      if (availableWidth >= estimatedWidth) {
        availableWidth -= estimatedWidth
        tagsToShow += 1
      } else {
        break
      }
    }

    setVisibleTags(tagsToShow)
    setShowMore(tagsToShow < currentlySelectedFiltersObjects.length)
  }, [currentlySelectedFiltersObjects, initialAvailableWidth])

  function removeTag(tagValue) {
    const newFilters = currentlySelectedFiltersObjects.reduce((acc, { value }) => {
      if (value !== tagValue) {
        acc.push(value)
      }
      return acc
    }, [])
    handleFilterChange(newFilters, tagValue, false)
  }

  return (
    <Fragment>
      {currentlySelectedFiltersObjects.slice(0, visibleTags || 1).map(({ label, value }) => {
        const displayLabel = functionToCleanLabel ? functionToCleanLabel(label) : label

        return (
          <TagComponent
            key={value}
            type="secondary"
            color="primary"
            className={tagClassName}
            onDeleteClick={() => removeTag(value)}
          >
            {displayLabel}
          </TagComponent>
        )
      })}
      {showMore && (
        <TagComponent
          type="secondary"
          color="primary"
        >
          +{currentlySelectedFiltersObjects.length - visibleTags}
        </TagComponent>
      )}
    </Fragment>
  )
}

FiltersTags.propTypes = {
  currentlySelectedFiltersObjects: arrayOf(object),
  handleFilterChange: func.isRequired,
  functionToCleanLabel: func,
  containerRef: object.isRequired,
  tagClassName: string,
}

export default FiltersTags
